import Vue from 'vue';
import store from '../store/store';
Array.prototype.remove = function (val) {
    var index = this.indexOf(val);
    if (index > -1) {
        this.splice(index, 1);
    }
};
/**
 * 从前往后找，找到第一个设备是运行时所在的索引序号
 * val：状态值
 * field:属性名称
 */
 Array.prototype.fakeFindFirstIndex = function(val, field) {
  let array = this;
  for (let i = 0; i < array.length - 1; i++) {
    const element = array[i][field];
    if (element == val || element == 3 || element == 2) {
      //3是没有阀门
      return i;
    }
  }
  return -1;
};
/**
 * 从后往前找，找到第一个设备是运行时所在的索引序号
 * val：状态值
 * field:属性名称
 */
Array.prototype.fakeFindLastIndex = function(val, field) {
  let array = this;
  for (let i = array.length - 1; i >= 0; i--) {
    const element = array[i][field];
    if (element == val || element == 3 || element == 2) {
      //3是没有阀门
      return i;
    }
  }
  return -1;
};
//声明----如果有此 contains 直接用最好
Array.prototype.contains = function ( needle ) {
    for (i in this) {
        if (this[i] == needle) return true;
    }
    return false;
}
//移除字符串两边的空格
String.prototype.trim = function(){
    return this.replace(/(^\s*)|(\s*$)/g,'');
}
//给Number类型增加一个sub方法，调用起来更加方便。
Number.prototype.reduce = function(arg) {
  return accSub(arg, this);
};
Array.prototype.diff = function(a) {
  return this.filter(function(i) {
    return a.indexOf(i) < 0;
  });
};
export default class common extends Vue {
    static first = null;

    /**
     * 防抖函数
     * @param {
     *  function
     * }
     * @returns {
     *  function
     * }
     */
    static debounce(fn, delay = 400) {
      let timeout = null;
      return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          fn.apply(context, args);
        }, delay);
      };
    }
    //节流函数
    static throttle(fn, delay = 1000) {
      let preTime = 0;
      return function () {
        const context = this;
        const args = arguments;
        const now = +new Date();
        if (now - preTime > delay) {
          fn.apply(context, args);
          preTime = now;
        }
      };
    }
    static getType(val) {
      if (val === null) return 'Null';
      if (val === undefined) return 'Undefined'; // IE9兼容
      let type = Object.prototype.toString.call(val);
      type = type.substring(8, type.length - 1);
      return type;
    }
    /**
     * 获取文件类型MIME_TYPE
     */
    static getMimeTypeList(extList = []) {
      let acceptList = [];
      const type = common.getType(extList);
      if (!['String', 'Array'].includes(type)) return acceptList;
      if (type === 'String') {
        extList = extList ? extList.split(',') : [];
      }
      extList.forEach((item) => {
        if (mimeTypeList[item]) acceptList.push(mimeTypeList[item]);
      });
      return acceptList;
    }
    //消息提示,防止重复提示的
    static message(params) {
      console.log('message :', common.first);
      if (common.first == null) {
        this.$message(params);
        common.first = new Date().getTime(); // 记录第一次按下回退键的时间
        setTimeout(function () {
          // 2s中后清除
          common.first = null;
        }, 2000);
      } else {
        if (new Date().getTime() - common.first > 2000) {
          // 如果两次按下的时间小于2s，
          common.first = null;
        }
      }
    }
          /**
   * 更新Loading状态
   * @param  status
   */
  static updateLoadingStatus(status) {
    // store.commit('base/updatePageLoadingStatus', status); //页面启用loading标识
    console.log(555555555555555555,status)
    store.commit('updateIsLoadingStatus', {
      isLoading: status,
    });
  }
    /**
   * 获取文件类型MIME_TYPE
   */
     static getMimeTypeList(extList = []) {
      let acceptList = [];
      const type = common.getType(extList);
      if (!['String', 'Array'].includes(type)) return acceptList;
      if (type === 'String') {
        extList = extList ? extList.split(',') : [];
      }
      extList.forEach((item) => {
        if (mimeTypeList[item]) acceptList.push(mimeTypeList[item]);
      });
      return acceptList;
    }

  }
